const UPDATE_LOG = "logs/UPDATE_LOG";
const UPDATE_SOURCE = "logs/UPDATE_SOURCE";
const UPDATE_LATEST_LOG = "logs/UPDATE_LATEST_LOG";
const IS_LOADING = "logs/IS_LOADING";
const IS_PARTIAL_LOADING = "logs/IS_PARTIAL_LOADING";
const ERROR = "logs/ERROR";
export { UPDATE_SOURCE, UPDATE_LOG, UPDATE_LATEST_LOG, IS_LOADING, IS_PARTIAL_LOADING, ERROR };
